<template>
    <div  >
        <div class="cp-main" ref="complete_main"  v-if="show_body">
            <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

            <div >
                <img class="logo" src="@a/explore/logo.png" />
                <!-- 报告内容 -->
                <div class="cp-header">
                    <img class="headimgurl" :src="data.headimgurl" />
                    <div class="cp-nickName">
                        <h2 class="text-ellipsis">{{data.nickname}}</h2>
                        <p>{{data.ctime}}</p>
                    </div>
                    <a  @click="resetCeping()" class="resetBtn">重新测试</a>
                </div>
                <!-- 报告分区 -->
                <div class="cp-box">
                    <h3 class="h3">以下为您的能力探索结果：</h3>
                    <!-- 能力区 -->
                    <div class="cp-Ability">
                        <div :class="['ability-box',`on${index}`]" v-for="(item,index) in objToArr(data.result)" :key="index" >
                            <h4>{{item}}</h4>
                            <div :class="['label',index==2 || index==3?'on':'']">
                                <div class="in" @click="doDetails(item2)" v-for="(item2,index2) in data.result[item]">{{item2}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 生成图片 -->
        <a @click="dataToImg()" class="dataDoimgBtn">生成图片</a>
        <van-popup class="pub_alert" v-model="popShow">
            <div class="des">
                <h3>{{explaining_obj.title}}</h3>
                <p>{{explaining_obj.val}}</p>
            </div>
        </van-popup>
        <!-- 以生成的图片 -->
        <van-popup class="pub_alert" v-model="imgShow">
            <div class="pop-img">
                <img :src="imgLink" />
            </div>
        </van-popup>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import { ceping68_report,ceping68_reset} from '@/api/measurement'
import { shareCon } from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";

import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

export default {
  data() {
      return {
        show_body: false,
        data:{},
        popShow:false,
        explaining_obj:{
            title:'',
            val:''
        },
        explaining:[],
        // 生成图片
        imgLink:'',
        imgShow:false
      }
    },
    components:{
      PublicAdQrcode,
      PublicTopTips,
    },
    methods: {
        // 点击生成图片
        dataToImg(){
            //调用加载中
            this.$emit('loadingHandle',true,"图片正在生成中，请长按保存...");
            window.pageYOffset = 0;
            document.documentElement.scrollTop = 0
            document.body.scrollTop = 0
            // 手动创建一个 canvas 标签
            const canvas = document.createElement("canvas")
            // 获取父标签，意思是这个标签内的 DOM 元素生成图片
            let canvasBox = this.$refs.complete_main
            // 获取父级的宽高
            const width = parseInt(window.getComputedStyle(canvasBox).width)
            const height = parseInt(window.getComputedStyle(canvasBox).height)
            
            let dpr = window.devicePixelRatio || 1;
            canvas.width = width * dpr;
            canvas.height = height * dpr;

            canvas.style.width = width + 'px';
            canvas.style.height = height + 'px';
            
            const context = canvas.getContext("2d");
            context.scale(1, 1);

            const options = {
                backgroundColor: null,
                canvas: canvas,
                logging: false,
                useCORS: true
            }
            html2canvas(canvasBox, options).then(canvas => {
                this.imgLink = canvas.toDataURL("image/png");
                setTimeout(()=>{
                    this.imgShow = true;
                   //关闭加载中
                    this.$emit('loadingHandle',false);
                }, 2000);
                
            });
            
        },
        // 展示点击的说明
        doDetails(val){
            for(let i =0;i<this.explaining.length;i++){
                if(this.explaining[i].divide==val){
                    this.explaining_obj['title'] = this.explaining[i].divide;
                    this.explaining_obj['val'] = this.explaining[i].explaining;
                    break;
                }
            }
            this.popShow = true;
        },
        // 重新测评
        resetCeping(){
            this.$dialog.confirm({
                title: '确认信息',
                message: '是否确认重新测评？'
            }).then(() => {
                //调用加载中
                this.$emit('loadingHandle',true,"正在加载中...");
                ceping68_reset().then((data)=>{
                    if (data.code == 10002) {
                        this.$toast(data.data.msg);
                        return false;
                    }
                    let redirect_query = deepCopy(this.$route.query);
                    if(redirect_query.evaluation_id) {
                      delete redirect_query.evaluation_id;
                    }
                    this.$router.push({
                        path:'/ceping68',
                        query: redirect_query
                    })

                    //关闭加载中
                    this.$emit('loadingHandle',false);
                }).catch((err)=>{
                    //关闭加载中
                    this.$emit('loadingHandle',false);
                });
            }).catch(() => {
                // on cancel
            });
        },
        // 对象转数组
        objToArr(arr){
          let a = Object.keys(arr);
          return a.length>0?a:[]
        },
        pullData() {
            //调用加载中
            this.$emit('loadingHandle',true,"正在加载中...");
            let q = this.$route.query;
            
            ceping68_report().then((data) => {

                if (data.code == 10002) {
                    if (this.formPath === '/ceping68') {
                        this.$router.back();
                    } else {
                        let redirect_query = deepCopy(this.$route.query);
                        if(redirect_query.evaluation_id) {
                          delete redirect_query.evaluation_id;
                        }
                        // 测评未完成
                        this.$router.push({
                            path:'/ceping68',
                            query: redirect_query
                        })
                    }

                } else {
                    this.data = data;
                    this.explaining = data.explaining;
                    document.title = data.headtitle;
                    
                    this.show_body = true;
                }
                //关闭加载中
                this.$emit('loadingHandle',false);
            })
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => { //  这里的vm指的就是vue实例，可以用来当做this使用
        vm.formPath = from.path;
      })
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.pop-img{
    width:710px;
    img{
        width:100%;
    }
}
.dataDoimgBtn{
    display:block;
    font-size:34px;
    color:#fff;
    text-align:center;
    margin:50px auto 80px;
    width:578px;
    line-height:80px;
    background:rgba(28,149,212,1);
    border-radius:40px;
    letter-spacing:1px;
}
.des{
    width:578px;
    border-radius:8px;
    padding:44px;
    background:#fff;
    h3{
        font-size:34px;
        margin-bottom:20px;
    }
    p{
        font-size:28px;
        line-height:39px;
    }
}
.cp-main{
    padding:30px 30px 0px 30px;
    .logo{
        width: 137px;
        height: 56px;
        margin-bottom: 22px;
    }
    .cp-header{
        background-color: #1C95D4;
        color:#fff;
        padding:40px;
        display:flex;
        border-radius:12px;
        .headimgurl{
            width:100px;
            height:100px;
            border-radius:50%;
            margin-right:20px;
            background-color: #fff;
        }
        .cp-nickName{
            h2{
                font-size:32px;
                margin-bottom:20px;
                width:215px;
            }
            p{
                font-size:24px;
            }
        }
        
        .resetBtn{
            display:block;
            border:2px solid #fff;
            border-radius:27px;
            font-size:26px;
            color:#fff;
            width:140px;
            margin:auto 0 auto auto;
            line-height:53px;
            height:53px;
            text-align:center;
        }
    }
    // 
    .cp-box{
        background-color: #fff;
        padding:50px 40px 40px;
        border-bottom-right-radius:12px;
        border-bottom-left-radius:12px;
        .h3{
            font-size:32px;
            color:#1C95D4;
            margin-bottom:80px;
            font-weight:bold;

        }
        .cp-Ability{
            display:flex;
            flex-wrap: wrap;
            width:100%;
            .ability-box{
                width:50%;
                min-height:370px;
                h4{
                    font-size:34px;
                    color:#333;
                    margin-top:30px;
                    margin-bottom:52px;
                    font-weight:bold;
                }
                .label{
                    display:flex;
                    flex-wrap: wrap;
                    .in{
                        font-size:28px;
                        color:#333;
                        padding: 4px 10px;
                        background:rgba(28,149,212,.16);
                        margin-right:20px;
                        margin-bottom:20px;
                        &:last-child{
                            margin-right:0px;
                        }
                    }
                    
                }
                .label.on{
                    .in{
                        background:rgba(82,21,255,.12);
                    }
                }
            }
            .ability-box.on0,.ability-box.on2{
                border-right:4px solid rgba(204,204,204,.4);
                position: relative;
            }

            .ability-box.on1,.ability-box.on3{
                padding-left:14px;
                position: relative;
            }
            .ability-box.on2,.ability-box.on3{
                border-top:4px solid rgba(204,204,204,.4);
            }
            .ability-box.on0:after{
                position:absolute;
                top:-5px;
                right:-14px;
                content:'';
                width:0;
                height:0;
                border-right:11.5px solid transparent;
                border-left:11.5px solid transparent;
                border-bottom:20px solid #e0dcdc;
            }
            .ability-box.on1:after{
                position:absolute;
                bottom:-14px;
                right:-5px;
                content:'';
                width:0;
                height:0;
                border-top:11.5px solid transparent;
                border-bottom:11.5px solid transparent;
                border-left:20px solid #e0dcdc;
            }
            .ability-box.on2:after{
                position:absolute;
                top:-14px;
                left:-5px;
                content:'';
                width:0;
                height:0;
                border-top:11.5px solid transparent;
                border-bottom:11.5px solid transparent;
                border-right:20px solid #e0dcdc;
            }
            .ability-box.on3:after{
                position:absolute;
                bottom:-5px;
                left:-12.5px;
                content:'';
                width:0;
                height:0;
                border-right:11.5px solid transparent;
                border-left:11.5px solid transparent;
                border-top:20px solid #e0dcdc;
            }
        }
    }
}

</style>
